import { Box, Typography } from "@mui/material";
import EventBusyOutlinedIcon from "@mui/icons-material/EventBusyOutlined";

export function JobEventEmpty() {
  return (
    <Box
      sx={{
        height: 260,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "text.secondary",
        gap: 1.5,
      }}
    >
      <EventBusyOutlinedIcon sx={{ fontSize: 40, opacity: 0.5 }} />

      <Typography variant="subtitle1" fontWeight={500}>
        No events found
      </Typography>

      <Typography variant="body2" sx={{ opacity: 0.7 }}>
        There are no job events for this status.
      </Typography>
    </Box>
  );
}
